module.exports = __webpack_public_path__ + "static/media/twitter-x.2affb007.png";